//  ----------      START   IMPORT  BLOCK       ----------
import { Modal } from 'react-bootstrap';
import chapterColors from '../../../ConfigFiles/chapter_colors';
import VocabInstructionsDiagnosis from '../../../ConfigFiles/multilingual/VocabInstructionsDiagnosis';
import './diagnosis_instructions.css';
//  ----------      END   IMPORT  BLOCK       ----------

//  Context
import { useLanguage } from '../../../API/Context/LanguageContext';

const DiagnosisInstructions = ({ show, onHide }) => {
  //  Consume context.
  const { lan } = useLanguage()

  const cie_chapters = [
    VocabInstructionsDiagnosis.chapter_01[lan],
    VocabInstructionsDiagnosis.chapter_02[lan],
    VocabInstructionsDiagnosis.chapter_03[lan],
    VocabInstructionsDiagnosis.chapter_04[lan],
    VocabInstructionsDiagnosis.chapter_05[lan],
    VocabInstructionsDiagnosis.chapter_06[lan],
    VocabInstructionsDiagnosis.chapter_07[lan],
    VocabInstructionsDiagnosis.chapter_08[lan],
    VocabInstructionsDiagnosis.chapter_09[lan],
    VocabInstructionsDiagnosis.chapter_10[lan],
    VocabInstructionsDiagnosis.chapter_11[lan],
    VocabInstructionsDiagnosis.chapter_12[lan],
    VocabInstructionsDiagnosis.chapter_13[lan],
    VocabInstructionsDiagnosis.chapter_14[lan],
    VocabInstructionsDiagnosis.chapter_15[lan],
    VocabInstructionsDiagnosis.chapter_16[lan],
    VocabInstructionsDiagnosis.chapter_17[lan],
    VocabInstructionsDiagnosis.chapter_18[lan],
    VocabInstructionsDiagnosis.chapter_19[lan],
    VocabInstructionsDiagnosis.chapter_20[lan],
    VocabInstructionsDiagnosis.chapter_21[lan],
    VocabInstructionsDiagnosis.chapter_22[lan],
  ];

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="wider-modal">
      <Modal.Header closeButton>
        <Modal.Title className="centered-modal-title">
          {VocabInstructionsDiagnosis.instructions_diagnosis_tittle[lan]}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p>
            {VocabInstructionsDiagnosis.content_1[lan]}{' '}
            <a href={VocabInstructionsDiagnosis.NOM_link[1]} target="_blank" rel="noopener noreferrer">
              {VocabInstructionsDiagnosis.NOM[lan]}
            </a>{' '}
            {VocabInstructionsDiagnosis.content_2[lan]}{' '}
            <a href={VocabInstructionsDiagnosis.CIE11_link[1]} target="_blank" rel="noopener noreferrer">
              {VocabInstructionsDiagnosis.CIE11[lan]}
            </a>{' '}
            {VocabInstructionsDiagnosis.content_3[lan]}
          </p>
          {/* List layout */}
          <ul>
            {cie_chapters.map((word, index) => (
              <li key={index} style={{ color: chapterColors[`chapter${index + 1 < 10 ? '0' : ''}${index + 1}Color`] || chapterColors.chapter00Color, fontWeight: 'bold' }}>
                {word}
              </li>
            ))}
          </ul>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DiagnosisInstructions;
